<footer class="footer ">
  <div class="container">
    <nav class="pull-left">
    </nav>
    <div class="copyright pull-right">
    </div>
  </div>
</footer>
